import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";
import RouteWithAPIFetch from "./RouteWithAPIFetch";

const AppRoute = ({
	user,
	component: Component,
	layout: Layout,
	isAuthProtected,
	...rest
}) => (
		<Route
			{...rest}
			render={props => {

				if ((isAuthProtected) && Object.keys(user)?.length===0 ) {
					return (
						<Redirect to={{ pathname: "/login", state: { from: props.location } }} />
					);
				}

				return (
					<Layout>
						<RouteWithAPIFetch Component={Component} {...props} />
						{/* <Component {...props} />  */}
					</Layout>
				);
			}}
		/>
	);

const mapStateToProps = (state) => ({
  user: state.Login.user,
});


export default connect(mapStateToProps)(AppRoute);